import styled, { css } from 'styled-components'

export const Container = styled.button<{ isLoading?: boolean }>`
  padding: 0;
  margin-left: auto;
  background: none;
  cursor: pointer;

  ${({ isLoading }) =>
    isLoading &&
    css`
      cursor: progress;
    `}
`
